import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { Card, Tag, brl, dataBR } from "../ui";

/** Aba "Assinaturas" do painel do admin — visão de todas + resumo (MRR). */
const AdminAssinaturas = () => {
    const [dados, setDados] = useState(null);

    useEffect(() => {
        api.get("/admin/assinaturas").then((r) => setDados(r.data)).catch(() => {});
    }, []);

    if (!dados) return <p className="text-muted">Carregando...</p>;
    const { resumo, assinaturas } = dados;

    const METRICAS = [
        { rotulo: "Com plano", valor: resumo.com_plano, apoio: "escritórios com mensalidade" },
        { rotulo: "Ativas", valor: resumo.ativas, apoio: "em dia" },
        { rotulo: "Vencidas", valor: resumo.vencidas, apoio: "precisam de atenção", alerta: resumo.vencidas > 0 },
        { rotulo: "Receita mensal", valor: brl(resumo.receita_mensal), apoio: "recorrente das ativas", destaque: true }
    ];

    return (
        <div>
            <div className="grid-cards">
                {METRICAS.map((m) => (
                    <Card key={m.rotulo} style={m.alerta ? { borderLeft: "3px solid #a32b1d" } : undefined}>
                        <span className="card-kicker">{m.rotulo}</span>
                        <span style={{ fontSize: m.destaque ? 24 : 30, fontFamily: "var(--font-heading)", fontWeight: 800, color: m.alerta ? "#a32b1d" : "var(--color-text)" }}>
                            {m.valor ?? "—"}
                        </span>
                        <span className="card-body text-muted">{m.apoio}</span>
                    </Card>
                ))}
            </div>

            <div className="scroll-x" style={{ marginTop: 12 }}>
                <table className="table">
                    <thead><tr><th>Escritório</th><th className="num">Valor</th><th>Vencimento</th><th>Situação</th></tr></thead>
                    <tbody>
                        {assinaturas.map((a) => (
                            <tr key={a.id_escritorio}>
                                <td>{a.nome_escritorio}</td>
                                <td className="num">{a.valor_mensal != null ? brl(a.valor_mensal) : "—"}</td>
                                <td>{a.data_vencimento ? dataBR(a.data_vencimento) : "—"}</td>
                                <td>
                                    {a.valor_mensal == null ? <span className="text-muted">sem plano</span>
                                        : a.vencida ? <Tag tom="danger">vencida{typeof a.dias_para_vencer === "number" ? ` (há ${Math.abs(a.dias_para_vencer)}d)` : ""}</Tag>
                                        : a.status === "ativa" ? <Tag tom="success">ativa{typeof a.dias_para_vencer === "number" ? ` · ${a.dias_para_vencer}d` : ""}</Tag>
                                        : <Tag tom="warn">{a.status}</Tag>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <p className="text-muted" style={{ fontSize: 13, marginTop: 8 }}>
                Para renovar ou ajustar o vencimento, abra o escritório na aba <strong>Escritórios</strong>.
            </p>
        </div>
    );
};

export default AdminAssinaturas;
